import Vue from "vue";
Vue.prototype.$EventBus = new Vue();
